import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { MarketingHeader } from "~/routes/(public)/header"

export const Route = createFileRoute("/_public-layout")({
  component: MarketingLayout,
  beforeLoad: ({ context, location }) => {
    // NOTE: We're not using the public marketing pages for this project, for now,
    // so we're just redirecting to either the sign in page or the dashboard based
    // on whether the user is authenticated or not.
    if (context.user) {
      throw redirect({
        to: "/dashboard",
      })
    }

    throw redirect({
      to: "/auth/sign-in",
      search: {
        next: location.href,
      },
    })
  },
})

function MarketingLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <MarketingHeader />
      <div className="flex shrink grow">
        <Outlet />
      </div>
    </div>
  )
}
